import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(pages)/(app)/page.tsx");
